import type { ResultList } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'

import type { ActionClass, IndexJobDTO, IndexState } from '../../../models'
import type { IndexJobService, IndexJobServiceListParams } from '../../../services/interfaces'

import { CONTAINER } from '../../../config/inversify.config'

import { TYPES } from '../../../config/inversify.types'

import { INDEX_CONSTS } from '../../../store/index/index.consts'

export class ListJobsAction implements ActionClass {
  static async execute(
    this: void,
    { commit }: ActionContext<IndexState, unknown>,
    params: IndexJobServiceListParams,
  ): Promise<ResultList<IndexJobDTO>> {
    const service = CONTAINER.get<IndexJobService>(TYPES.IndexJobService)
    const response = await service.list(params)
    commit(INDEX_CONSTS.mutations.setJobs, response.results)
    return response
  }
}
